export default __webpack_public_path__ + "8c7db2c7c66861e6feda385ba1132153.png";